import React, {useEffect, useRef, useState} from 'react';
import Toast, {newToast} from '../../snackbar/components/LoadingToast';
import {AvField, AvForm, AvGroup} from 'availity-reactstrap-validation';
import {Button, Col, Container, FormGroup, Label, Row, Spinner} from 'reactstrap';
import validator from 'validator';
import {useDispatch, useSelector} from 'react-redux';
import {
  submitAutoPayCollection,
  updateCreditCardForm
} from '../api/actions';
import {useHistory, useLocation} from 'react-router-dom';
import moment from 'moment/moment';
import {getAllCreditCardTypes} from "../../apl/api/actions";


const CCPaymentFormAutopay = () => {

  const [currentToasts, setCurrentToast] = useState([]);
  const formRef = useRef();
  const formValues = useSelector(state => state.paymentMethods.cardPaymentMethod);
  const creditCardTypes = useSelector(state => state.apl.genericTypes.creditCardType);
  const creditCardData = (creditCardTypes.data || []).filter(desc => desc.id != 1 && desc.id != 2);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const legacyUserId = queryParams.get('legacyUserId');
  const token = queryParams.get('token');

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(getAllCreditCardTypes());
  }, [dispatch]);

  const onChange = (e) => {
    const {name, value} = e.target;
    dispatch(updateCreditCardForm(name, value));
    if (name === 'ccTypeId') {
      const row = creditCardData.find((t) => Number(t.id) === Number(value));
      if (row) {
        dispatch(updateCreditCardForm('ccType', row.description));
      }
    }
  };

  const handleSubmit = async () => {
    try {
      const toast = newToast('Saving New Payment Method', 'Processing', true);
      setCurrentToast([toast]);
      const res = await dispatch(submitAutoPayCollection(formValues, token, legacyUserId));
      if (res.status === 200) {
        history.push('/auto-pay-collection-confirmation');
      } else {
        const errorToast = newToast('Failed to save payment method. Please Try Again', 'Error', false);
        setCurrentToast([errorToast]);
      }
    } catch (error) {
      const errorToast = newToast('Failed to save payment method. Please Try Again', 'Error', false);
      setCurrentToast([errorToast]);
    }
  };


  const validateCreditCard = (value, ctx) => {
    return validator.isCreditCard(value)
  }

  const validateMinYear = (value) => +value >= moment().year();


  return (
    <div>
      <Toast
        toastList={currentToasts}
        position="bottom-right"
        autoDelete={true}
        autoDeleteTime={10000}
      />
      <Container>
        <Row className="mt-5 align-content-lg-stretch">
          <Col className="col-9">
            <h5 className="text-md-left text-center">Credit / Debit Card Information:</h5>
          </Col>
        </Row>
        <AvForm ref={formRef} onValidSubmit={handleSubmit} className="payment-details-form mt-4">
          <Row className="mt-4">
            <Col className="col-12">
              <AvGroup className="position-relative">
                <Label>What should this payment method be saved as?</Label>
                <AvField
                  type="text"
                  className="form-control"
                  errorMessage="Invalid Payment Title"
                  value={formValues.saveName}
                  onChange={onChange}
                  validate={{required: {value: true}}}
                  placeholder="Save Payment Type as"
                  name="saveName"
                />
              </AvGroup>
            </Col>
            <Col className="col-md-6" style={{flexBasis: 'auto'}}>
              <AvGroup className="position-relative">
                <Label>Card Number</Label>
                <AvField
                  type="text"
                  className="form-control"
                  errorMessage="Invalid Card Number"
                  value={formValues.ccNum}
                  maxLength={16}
                  onChange={onChange}
                  validate={{myValidation: validateCreditCard}}
                  placeholder="Card Number :"
                  name="ccNum"
                />
              </AvGroup>
            </Col>
            <Col className="col-md-6" style={{flexBasis: 'auto'}}>
              <AvGroup className="position-relative">
                {creditCardTypes.isLoading ?
                  <Col lg={12} className="text-center mt-2 mb-2">
                    <Spinner color="blue" size="lg" />
                  </Col>
                  :
                  <AvField type="select"
                           name="ccTypeId"
                           label="Credit/Debit Card Type"
                           value={formValues.ccTypeId}
                           onChange={onChange}
                           validate={{required: {value: true}}}>
                    {creditCardData.map(type => (
                      <option
                        key={type.id}
                        value={type.id}>
                        {type.description}
                      </option>
                    ))
                    }
                  </AvField>
                }
              </AvGroup>
            </Col>
            <Col className="col-12">
              <AvGroup className="position-relative">
                <Label>Name On Card</Label>
                <AvField
                  type="text"
                  className="form-control"
                  errorMessage="Invalid Name On Card"
                  value={formValues.nameOnCard}
                  onChange={onChange}
                  validate={{required: {value: true}}}
                  placeholder="Card Owner :"
                  name="nameOnCard"
                />
              </AvGroup>
            </Col>
            <Col className="col-md-4" style={{flexBasis: 'auto'}}>
              <AvGroup className="position-relative">
                <Label>Card Expiration Month (MM):</Label>
                <AvField
                  type="number"
                  className="form-control"
                  errorMessage="Invalid Month"
                  value={formValues.ccExpMonth}
                  onChange={onChange}
                  validate={{
                    required: {value: true},
                    pattern: {value: /^(0?[1-9]|1[012])$/},
                  }}
                  placeholder="Expiration Month :"
                  name="ccExpMonth"
                />
              </AvGroup>
            </Col>
            <Col className="col-md-4" style={{flexBasis: 'auto'}}>
              <AvGroup className="position-relative">
                <Label>Card Expiration Year (YYYY):</Label>
                <AvField type="number" className="form-control" errorMessage="Invalid Year"
                         value={formValues.ccExpYear}
                         onChange={onChange}
                         validate={{
                           required: {value: true},
                           pattern: {value: /^(19|20)\d{2}$/},
                           custom: validateMinYear
                         }}
                         placeholder="Expiration Year :"
                         name="ccExpYear"/>
              </AvGroup>
            </Col>
            <Col className="col-md-4" style={{flexBasis: 'auto'}}>
              <AvGroup className="position-relative">
                <Label>CVV:</Label>
                <AvField
                  type="number"
                  className="form-control"
                  errorMessage="Invalid CVV"
                  value={formValues.cardCvv}
                  onChange={onChange}
                  validate={{
                    required: {value: true},
                    pattern: {value: /^[0-9]{3,4}$/},
                  }}
                  placeholder="CVV# :"
                  name="cardCvv"
                />
              </AvGroup>
            </Col>
            {/*<Col className="col-4"></Col>*/}
            <h5 className="text-md-left text-center  m-3">Billing Information :</h5>
            <Col className="col-12">
              <AvGroup className="position-relative">
                <Label>Street Address:</Label>
                <AvField
                  type="text"
                  className="form-control"
                  errorMessage="Invalid Address"
                  value={formValues.billingAddress1}
                  onChange={onChange}
                  autoComplete="off"
                  validate={{required: {value: true}}}
                  name="billingAddress1"
                />
              </AvGroup>
            </Col>
            <Col className="col-12">
              <FormGroup className="position-relative">
                <Label>Address Apt: </Label>
                <AvField
                  type="text"
                  className="form-control"
                  errorMessage="Invalid Address"
                  value={formValues.billingAddress2}
                  onChange={onChange}
                  autoComplete="off"
                  validate={{}}
                  name="billingAddress2"
                />
              </FormGroup>
            </Col>
            <Col className="col-md-4 col-sm-6" style={{flexBasis: 'auto'}}>
              <FormGroup className="position-relative">
                <Label>City: </Label>
                <AvField
                  type="text"
                  className="form-control"
                  errorMessage="Invalid City"
                  value={formValues.billingCity}
                  onChange={onChange}
                  autoComplete="off"
                  validate={{required: {value: true}}}
                  name="billingCity"
                />
              </FormGroup>
            </Col>
            <Col className="col-md-4 col-sm-6">
              <FormGroup className="position-relative">
                <Label>State: </Label>
                <AvField
                  type="text"
                  className="form-control"
                  errorMessage="Invalid State"
                  value={formValues.billingState}
                  onChange={onChange}
                  autoComplete="off"
                  validate={{required: {value: true}}}
                  name="billingState"
                />
              </FormGroup>
            </Col>
            <Col className="col-md-4 col-sm-6">
              <FormGroup className="position-relative">
                <Label>Zip: </Label>
                <AvField
                  type="text"
                  className="form-control"
                  errorMessage="Invalid Zip"
                  value={formValues.billingZip}
                  onChange={onChange}
                  autoComplete="off"
                  validate={{required: {value: true}}}
                  name="billingZip"
                />
              </FormGroup>
            </Col>
            <Col className="col-12">
              <AvGroup className="position-relative">
                <Label>Email:</Label>
                <AvField
                  type="text"
                  className="form-control"
                  errorMessage="Invalid Email"
                  value={formValues.email}
                  onChange={onChange}
                  autoComplete="off"
                  validate={{required: {value: true}}}
                  name="email"
                />
              </AvGroup>
            </Col>
            <Col lg={12} className="mb-0 ml-0">
              <FormGroup>
                <Button color="primary" type="submit">
                  Save Payment Method
                </Button>
              </FormGroup>
            </Col>
          </Row>
        </AvForm>
      </Container>
    </div>
  );
};

export default CCPaymentFormAutopay;
